import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class FordCrossingTileEntity1 extends TileEntity {
	public static readonly frameName = FrameName.FORD_CROSSING_1;
}

export default FordCrossingTileEntity1;
